import { useIntl } from 'react-intl'
import HighlightLabel from 'LuxKit/Label/HighlightLabel'

interface Props {
  offer: App.MerchandiseOffer
}

function MerchandiseFreeShippingLabel({ offer }: Props) {
  const intl = useIntl()

  if (!offer.hasFreeShipping) {
    return null
  }

  return <HighlightLabel>
    {intl.formatMessage({
      id: 'r4OinbkHXfGd9ZMdH1B4',
      defaultMessage: 'Free shipping',
      description: 'Label shown when merchandise offer has free shipping',
    })}
  </HighlightLabel>
}

export default MerchandiseFreeShippingLabel
